export const LOADING_EQUIPMENT_TOAST = "LOADING_EQUIPMENT_TOAST";
export const UPDATING_EQUIPMENT_TOAST = "UPDATING_EQUIPMENT_TOAST";

export const CHECKING_IN_OUT_TOAST = "CHECKING_IN_OUT_TOAST";
